import { useTranslation } from 'react-i18next';

import { useSearchParams } from '@remix-run/react';

import { getPostSortOptions, POST_SORT_DEFAULT, type PostSortOption, type PostSortValue } from '~/constants/community';

export const usePostSortOrder = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const options: [PostSortOption, ...PostSortOption[]] = getPostSortOptions(t);

  const rawValue = searchParams.get('sort');
  const currentOption: PostSortOption = options.find((o) => o.value === rawValue) ?? options[0];

  const setSort = (value: PostSortValue) => {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev);
        if (value === POST_SORT_DEFAULT) params.delete('sort');
        else params.set('sort', value);
        return params;
      },
      { replace: true },
    );
  };

  return { options, currentOption, setSort };
};
